
import Vue from "vue";
import AMapVue from './AMap/index.vue'

import ThreeModelVue from './3DModel/index.vue'

import DeviceControllerVue from './deviceController.vue/index.vue'

import QRCodeVue from './QRCode/index.vue'

// 设置dom元素的舞台坐标
let setElemPosition = globalThis.coreTopology?.setElemPosition;

let plans = {}

function onAdd(pen) {
    pen.beforeScale = pen.calculative.canvas.store.data.scale;
}


function move(pen) {
    if (!plans[pen.id]) {
        return;
    }
    setElemPosition(pen, plans[pen.id].div);
}



function destory(pen) {
    if (!plans[pen.id]) return;

    plans[pen.id].div.remove();
    plans[pen.id].ui = undefined;
    plans[pen.id] = undefined;
    delete plans[pen.id];
    document.querySelectorAll(`#controller-${pen.id}-moving`)
        .forEach(dom => {
            dom.remove()
        });

}


/**
 * 创建ui
 * @returns {Vue.component}
 */
function createUI(container, component) {
    let Profile = Vue.extend(component)
    let div = document.createElement('div')
    container.appendChild(div)
    // 创建 Profile 实例，并挂载到一个元素上。
    return new Profile().$mount(div)
}

function init(pen, component) {
    if (!setElemPosition) {
        setElemPosition = globalThis.coreTopology.setElemPosition;
    }
    if (!pen.onDestroy) {
        pen.onDestroy = destory;
        pen.onMove = move;
        pen.onRotate = move;
        pen.onMouseEnter = move;
        pen.onAdd = onAdd;
        pen.onResize = move;
    }

    const path = new Path2D();

    // 世界坐标对象
    const worldRect = pen.calculative.worldRect;

    if ((!plans[pen.id] || !plans[pen.id].div) && (pen.id.indexOf('moving') == -1)) {

        // 创建容器
        const div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.outline = 'none';
        div.style.left = '-9999px';
        div.style.top = '-9999px';
        div.id = 'controller-' + pen.id;
        div.style.width = worldRect.width + 'px';
        div.style.height = worldRect.height + 'px';
        // document.body.appendChild(div);



        // 加载到div layer视图层
        pen.calculative.canvas.externalElements?.appendChild(div);

        // 创建界面
        let ui = createUI(div, component)

        plans[pen.id] = {
            div,
            ui
        }
        setElemPosition(pen, div);
    }

    // 设置背景
    if (plans[pen.id] !== undefined &&  plans[pen.id].div !== undefined) {
        pen.calculative.background && (plans[pen.id].div.style.backgroundColor = pen.calculative.background);
        pen.calculative.color && (plans[pen.id].div.style.color = pen.calculative.color);
        pen.calculative.backgroundImage && (plans[pen.id].div.style.backgroundImage = `url(${pen.calculative.backgroundImage})`);
        pen.calculative.backgroundImage && (plans[pen.id].div.style.backgroundSize = 'cover');
        pen.calculative.zIndex && (plans[pen.id].div.style.zIndex = pen.calculative.zIndex);
    }


    path.rect(worldRect.x, worldRect.y, worldRect.width, worldRect.height);
    if (pen.calculative.patchFlags && plans[pen.id] && plans[pen.id].div) {
        setElemPosition(pen, plans[pen.id].div);
    }
    return path
}


/**
 * 地图
 * @param {Object} pen 
 * @returns 
 */
const AMapLibs = pen => {
    const path = init(pen, AMapVue)
    if (plans[pen.id]) {
        plans[pen.id].div.style.zIndex = pen.calculative.zIndex;
        // 设置默认坐标
        const location = pen.location?.split(',');
        if (location && location.length === 2) {
            plans[pen.id].ui.location = location
        }
        if (pen.zoom) {
            plans[pen.id].ui.zoom = pen.zoom
        }
        if (pen.city) {
            plans[pen.id].ui.city = pen.city
        }
        plans[pen.id].ui.penID = pen.id
        setElemPosition(pen, plans[pen.id].div);
    }
    // 赋值
    pen.onValue = () => {
        if (plans[pen.id]) {

            // 设置默认坐标
            const location = pen.location?.split(',');
            if (location && location.length === 2) {
                plans[pen.id].ui.location = location
            }
            if (pen.zoom) {
                plans[pen.id].ui.zoom = pen.zoom
            }
            if (pen.city) {
                plans[pen.id].ui.city = pen.city
            }
            plans[pen.id].ui.penID = pen.id
            setElemPosition(pen, plans[pen.id].div);
        }
    }
    return path
}

/**
 * 3D场景
 * @param {Object} pen 
 * @returns 
 */
const ThreeModel = pen => {
    return init(pen, ThreeModelVue)
}

/**
 * 设备控制
 * @param {Object} pen 
 * @returns 
 */
const DeviceController = pen => {
    return init(pen, DeviceControllerVue)
}

/**
 * 二维码生成
 * @param {Object} pen 
 * @returns 
 */
const qrcode = pen => {
    const path = init(pen, QRCodeVue)
    if (plans[pen.id]) {
        plans[pen.id].ui.text = pen.qrcodeText;
    }
    // 赋值
    pen.onValue = () => {
        if (plans[pen.id]) {
            plans[pen.id].ui.text = pen.qrcodeText;
        }
        setElemPosition(pen, plans[pen.id].div);
    }

    return path;
}

export {
    AMapLibs, ThreeModel, DeviceController, qrcode
}